// Canonical display order for counter kinds - Black pages, then Color pages,
// then Scanned pages - regardless of the order counters come back from the
// API (which is typically sorted by read date or position, not kind).
export const COUNTER_KIND_ORDER: Record<string, number> = { BP: 0, CP: 1, SP: 2 };

export const getCounterKindSortIndex = (kind?: string | null): number =>
  kind ? COUNTER_KIND_ORDER[kind] ?? 99 : 99;

export const compareByCounterKind = (a?: string | null, b?: string | null): number =>
  getCounterKindSortIndex(a) - getCounterKindSortIndex(b);
